export const ROLES = {
  Admin: 'Admin',
  CompanyUser: 'Company User',
  CompanyAdmin: 'Company Admin',
};

export default {
  ADMIN: 'Admin',
  CUSTOMER: 'Customer',
  COMPANY_ADMIN: 'CompanyAdmin',
  COMPANY_USER: 'CompanyUser',
};
